import { translate } from '@teamleader/i18n';
import React, { useCallback, useContext } from 'react';

import { getDaysUntilExpiration } from './utils';
import Banner from '../../../../Components/UI/Banner';
import Link from '../../../../Components/UI/Link';
import { QUOTATION_STATUS } from '../../../../Types/quotation';
import { MENUS } from '../../../../Utils/Menus';
import { EVENTS, track } from '../../../../Utils/analytics';
import { MODES, UrlContext } from '../../../../Utils/jwt';
import useGlobalContext, { DealContext } from '../../Context';

const ExpiryQuotationBanner: React.FC = () => {
  const { quotation } = useContext(DealContext);

  const { handleOpenMenu } = useGlobalContext();
  const { mode } = useContext(UrlContext);
  const isPreviewMode = mode === MODES.PREVIEW;
  const handleRequest = useCallback(() => {
    handleOpenMenu!(MENUS.REQUEST);
    track(EVENTS.STARTED_REQUESTING, { fromHeader: true });
  }, [handleOpenMenu]);

  if (!quotation) {
    return null;
  }

  const isExpired = quotation.status === QUOTATION_STATUS.EXPIRED;
  const isAccepted = quotation.status === QUOTATION_STATUS.ACCEPTED;
  const isRefused = quotation.status === QUOTATION_STATUS.REFUSED;
  const expiresAfter = quotation.expiry?.expiresAfter;
  const lockAfterExpiry = quotation.expiry?.lockedAfterExpiry ?? false;
  const daysUntilExpiration = getDaysUntilExpiration(expiresAfter);

  if ((!isExpired && (daysUntilExpiration === 0 || daysUntilExpiration > 7)) || isAccepted || isRefused) {
    return null;
  }

  return (
    <Banner
      label={
        <>
          {isExpired
            ? translate('expiredQuotation.isExpired')
            : daysUntilExpiration === 1
            ? translate('expiredQuotation.willExpireTomorrow')
            : translate('expiredQuotation.willExpire', { amount: daysUntilExpiration })}{' '}
          {isExpired && lockAfterExpiry && !isPreviewMode ? (
            <Link inherit={false} onClick={handleRequest} style={{ textDecoration: 'underline', color: 'inherit' }}>
              {translate('expiredQuotation.requestNew')}
            </Link>
          ) : (
            ''
          )}
        </>
      }
      variant={isExpired ? 'error' : 'warning'}
    />
  );
};

export default ExpiryQuotationBanner;
